import PropTypes from "prop-types";

import LegacyModal from "./LegacyModal";
import DsModal from "./Modal";

const Modal = ({ useDesignSystem = false, ...rest }) => {
  if (useDesignSystem) {
    return <DsModal {...rest} />;
  }
  return <LegacyModal {...rest} />;
};

Modal.propTypes = {
  useDesignSystem: PropTypes.bool,
};
Modal.displayName = "Modal";

export default Modal;
